import React from 'react';
import {SPECS} from '../../../../../common/constants';
import {useExperiments, useEnvironment} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {Totals} from '../../../../../common/components/Totals/Totals';
import {TotalsSectionDataHooks} from '../TotalsSection';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {getTaxName, getTaxesWithSomeTaxExemption} from '../../../../../domain/utils/total.util';
import {TaxModel} from '../../../../../domain/models/checkout/CartSummary/Tax.model';
import {TotalUpdateSkeleton} from '../../TotalUpdateSkeleton';
import {getTaxValue} from './Tax.utils';

export const TaxTotalsRow = () => {
  const {cart, cartSummary, isCartSummaryUpdating} = useControllerProps().checkoutStore;
  const {checkoutSettings} = useControllerProps().checkoutSettingsStore;
  const {experiments} = useExperiments();
  const {isRTL} = useEnvironment();
  const localeKeys = useLocaleKeys();
  const taxIncludedInPrice = cart.taxInfo.pricesIncludeTax;
  const moveCheckoutToViewerContext = experiments.enabled(SPECS.MoveCheckoutToViewerContext);
  const supportTaxExemptionOnCheckout = experiments.enabled(SPECS.SupportTaxExemptionOnCheckout);
  const isTaxConfigured = moveCheckoutToViewerContext ? checkoutSettings.isTaxConfigured : true;

  const getTaxRowsToDisplay = () => {
    if (taxIncludedInPrice) {
      if (supportTaxExemptionOnCheckout) {
        return getTaxesWithSomeTaxExemption(cartSummary!.taxSummary.taxes);
      } else {
        return [];
      }
    } else {
      return cartSummary!.taxSummary.taxes;
    }
  };

  const taxRowsToDisplay = getTaxRowsToDisplay();

  if (taxRowsToDisplay.length === 0 || !isTaxConfigured) {
    return;
  }

  const getTaxValueOrSkeleton = (tax: TaxModel) => {
    return isCartSummaryUpdating
      ? () => <TotalUpdateSkeleton />
      : getTaxValue({
          tax,
          isTaxIncludedInPrice: !!taxIncludedInPrice,
          isRTL,
          localeKeys,
          supportTaxExemptionOnCheckout,
        });
  };

  if (taxRowsToDisplay.length === 1) {
    const tax = taxRowsToDisplay[0];
    return (
      <Totals.TotalsRow
        dataHook={TotalsSectionDataHooks.TaxRow}
        title={getTaxName({
          taxName: tax.name,
          checkoutSettings,
          localeKeys,
          moveCheckoutToViewerContext,
        })}
        value={getTaxValueOrSkeleton(tax)}
      />
    );
  }

  return (
    <Totals.TotalsSection
      title={localeKeys.checkout.order_summary.totals.tax()}
      dataHook={TotalsSectionDataHooks.TaxSection}>
      {taxRowsToDisplay.map((tax, index) => (
        <Totals.TotalsRow
          dataHook={TotalsSectionDataHooks.TaxRow}
          key={index}
          title={getTaxName({
            taxName: tax.name,
            checkoutSettings,
            localeKeys,
            moveCheckoutToViewerContext,
          })}
          value={getTaxValueOrSkeleton(tax)}
        />
      ))}
    </Totals.TotalsSection>
  );
};
